import { getUsersProfile } from '../../../../api/users';

//Components
import MyAccountInfo from '../components/MyAccountInfo';

export default function (page) {
  return getUsersProfile().then(({ data }) => {
    const { email, active_streams, max_concurrent_streams } = data.user;

    const items = [
      {
        w: 1920,
        h: 1080,
        type: MyAccountInfo,
        active_streams,
        max_concurrent_streams,
        email,
      },
    ];
    page._MyAccountInfo.items = items;
  });
}
